<template>
  <div
    class="candidate-info-box pointer-events-none flex flex-col justify-center"
    :class="{
      'text-white candidate-info-box-s': shortVersion,
      'candidate-info-box-l': !shortVersion
    }"
    :style="{ 'background-color': lightTheme ? '#302f40' : null }"
  >
    <!-- Party & List Places -->
    <div
      class="text-chplus-regular min-w-0 w-full"
      :class="{ 'text-interaction-dark': !lightTheme }"
      style="line-height: 0"
    >
      <template v-if="candidate.partyId > 0 || candidate.parliamentPartyId > 0">
        <div
          ref="partyLogo"
          v-if="candidate.partyLogo != null && candidate.partyLogo.length > 0"
          class="party-logo mx-auto inline-block"
          :class="{
            'p-1 rounded-lg': lightTheme
          }"
          :style="{
            'background-color': lightTheme ? 'rgba(255,255,255,0.35)' : null
          }"
        ></div>
        <div
          v-else
          class="mx-auto"
          :class="{
            'inline-block': !lightTheme,
            'block p-1 rounded-lg': lightTheme
          }"
        ></div>
      </template>
      <span
        class="block"
        style="line-height: 1em"
        :class="{ 'whitespace-no-wrap overflow-hidden': shortVersion }"
        :style="{ 'text-overflow': shortVersion ? 'ellipsis' : null }"
        >{{ candidate.partyName }}</span
      >
      <template v-if="!shortVersion && listPlaces != null">
        <list-place
          :key="index"
          v-for="(listPlace, index) of listPlaces"
          :list-place="listPlace"
        />
      </template>
    </div>
    <!-- Personal Details -->
    <div
      class="candidate-info-container flex flex-col flex-grow justify-between text-chplus-candidate-info min-w-0 max-w-full"
      :class="{ 'text-color-candidate': !lightTheme }"
    >
      <occupation
        v-if="candidate.occupation"
        :candidate="candidate"
        :shortVersion="shortVersion"
      />
      <birthday
        v-if="candidate.birthYear"
        :candidate="candidate"
        :shortVersion="shortVersion"
      />
      <city
        v-if="candidate.city"
        :candidate="candidate"
        :shortVersion="shortVersion"
      />
    </div>
  </div>
</template>

<script>
import ListPlace from "@/components/people/ListPlace";
import Birthday from "@/components/people/profile/Birthday";
import City from "@/components/people/profile/City";
import Occupation from "@/components/people/profile/Occupation.vue";

export default {
  name: "CandidateInfoBox",
  components: { ListPlace, Birthday, City, Occupation },
  props: {
    shortVersion: {
      type: Boolean,
      default: false
    },
    candidate: {
      type: Object,
      required: true
    },
    lightTheme: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listPlaces() {
      const allListPlaces = this.candidate.listPlaces || [];
      const getList = this.$store.getters["list/list"];
      return allListPlaces.filter(
        p => p.listId == null || p.listId === 0 || getList(p.listId) != null
      );
    }
  },
  mounted() {
    this.updatePartyLogo();
    setTimeout(() => {
      this.updatePartyLogo();
    }, 50);
  },
  watch: {
    candidate() {
      this.updatePartyLogo();
      setTimeout(() => {
        this.updatePartyLogo();
      }, 50);
    }
  },
  methods: {
    updatePartyLogo() {
      if (this.$refs.partyLogo) {
        if (this.candidate.partyLogo) {
          this.$refs.partyLogo.innerHTML =
            "<img " +
            'class="h-full mx-auto"' +
            (this.lightTheme ? 'style="border-radius: 0.5rem"' : "") +
            ' src="' +
            this.candidate.partyLogo +
            '" alt=""' +
            "/>";
        } else {
          this.$refs.partyLogo.innerHTML = "";
        }
      }
    }
  }
};
</script>
